import { ConnectedVisualizer } from './visualizer'

export { Visualizer, ConnectedVisualizer } from './visualizer'
export default ConnectedVisualizer